export default __webpack_public_path__ + "static/events-light-41c1201815d86272f03f45a4c589f125.png";